/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Build_Update_AvailableInputs */

const th_build_update_available = /** @type {(inputs: Build_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มีเวอร์ชันใหม่ — โหลดใหม่`)
};

const en_build_update_available = /** @type {(inputs: Build_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update available — reload`)
};

const ja_build_update_available = /** @type {(inputs: Build_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいバージョンがあります — 再読み込み`)
};

const zh_build_update_available = /** @type {(inputs: Build_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有更新可用——请重新加载`)
};

const es_build_update_available = /** @type {(inputs: Build_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualización disponible: recarga`)
};

const pt_build_update_available = /** @type {(inputs: Build_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualização disponível — recarregue`)
};

const id_build_update_available = /** @type {(inputs: Build_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembaruan tersedia — muat ulang`)
};

const fr_build_update_available = /** @type {(inputs: Build_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mise à jour disponible — rechargez`)
};

const tl_build_update_available = /** @type {(inputs: Build_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`May update — i-reload`)
};

const vi_build_update_available = /** @type {(inputs: Build_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã có bản cập nhật — tải lại`)
};

const ko_build_update_available = /** @type {(inputs: Build_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`업데이트가 있습니다 — 새로 고침`)
};

const de_build_update_available = /** @type {(inputs: Build_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update verfügbar — neu laden`)
};

const ru_build_update_available = /** @type {(inputs: Build_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступно обновление — обновите страницу`)
};

const tr_build_update_available = /** @type {(inputs: Build_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Güncelleme var — yeniden yükleyin`)
};

const it_build_update_available = /** @type {(inputs: Build_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiornamento disponibile — ricarica`)
};

const pl_build_update_available = /** @type {(inputs: Build_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostępna aktualizacja — odśwież`)
};

const uk_build_update_available = /** @type {(inputs: Build_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступне оновлення — перезавантажте`)
};

const hi_build_update_available = /** @type {(inputs: Build_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपडेट उपलब्ध — पुनः लोड करें`)
};

const ar_build_update_available = /** @type {(inputs: Build_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يوجد تحديث — أعد التحميل`)
};

const ms_build_update_available = /** @type {(inputs: Build_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kemas kini tersedia — muat semula`)
};

const bn_build_update_available = /** @type {(inputs: Build_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`হালনাগাদ এসেছে — পুনরায় লোড করুন`)
};

const zh_tw2_build_update_available = /** @type {(inputs: Build_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有更新可用——請重新載入`)
};

const zh_hk2_build_update_available = /** @type {(inputs: Build_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有更新可用——請重新載入`)
};

const ur_build_update_available = /** @type {(inputs: Build_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اپ ڈیٹ دستیاب ہے — دوبارہ لوڈ کریں`)
};

const fa_build_update_available = /** @type {(inputs: Build_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`به‌روزرسانی موجود است — دوباره بارگذاری کنید`)
};

const sw_build_update_available = /** @type {(inputs: Build_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuna sasisho — pakia upya`)
};

const nl_build_update_available = /** @type {(inputs: Build_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update beschikbaar — herladen`)
};

/**
* | output |
* | --- |
* | "Update available — reload" |
*
* @param {Build_Update_AvailableInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const build_update_available = /** @type {((inputs?: Build_Update_AvailableInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Build_Update_AvailableInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_build_update_available(inputs)
	if (locale === "ja") return ja_build_update_available(inputs)
	if (locale === "zh") return zh_build_update_available(inputs)
	if (locale === "es") return es_build_update_available(inputs)
	if (locale === "pt") return pt_build_update_available(inputs)
	if (locale === "id") return id_build_update_available(inputs)
	if (locale === "fr") return fr_build_update_available(inputs)
	if (locale === "tl") return tl_build_update_available(inputs)
	if (locale === "vi") return vi_build_update_available(inputs)
	if (locale === "ko") return ko_build_update_available(inputs)
	if (locale === "de") return de_build_update_available(inputs)
	if (locale === "ru") return ru_build_update_available(inputs)
	if (locale === "tr") return tr_build_update_available(inputs)
	if (locale === "it") return it_build_update_available(inputs)
	if (locale === "pl") return pl_build_update_available(inputs)
	if (locale === "uk") return uk_build_update_available(inputs)
	if (locale === "hi") return hi_build_update_available(inputs)
	if (locale === "ar") return ar_build_update_available(inputs)
	if (locale === "ms") return ms_build_update_available(inputs)
	if (locale === "bn") return bn_build_update_available(inputs)
	if (locale === "zh-TW") return zh_tw2_build_update_available(inputs)
	if (locale === "zh-HK") return zh_hk2_build_update_available(inputs)
	if (locale === "ur") return ur_build_update_available(inputs)
	if (locale === "fa") return fa_build_update_available(inputs)
	if (locale === "sw") return sw_build_update_available(inputs)
	if (locale === "nl") return nl_build_update_available(inputs)
	return en_build_update_available(inputs)
});